import httpClient from './httpClient';
import { API_CONFIG } from './index';

class SizesService {
  // Get all sizes with optional filtering
  async getSizes(filters = {}) {
    try {
      let endpoint = '/api/admin/sizes';
      const queryParams = new URLSearchParams();
      
      if (filters.category_id) {
        queryParams.append('category_id', filters.category_id);
      }
      
      if (filters.search) {
        queryParams.append('search', filters.search);
      }
      
      if (queryParams.toString()) {
        endpoint += `?${queryParams.toString()}`;
      }
      
      console.log('SizesService: Making request to', endpoint);
      console.log('SizesService: Full URL will be:', API_CONFIG.BASE_URL + endpoint);
      console.log('SizesService: Filters:', filters);
      
      const response = await httpClient.get(endpoint);
      console.log('SizesService: Raw response from httpClient:', response);
      console.log('SizesService: Response type:', typeof response);
      console.log('SizesService: Response keys:', Object.keys(response || {}));
      
      // httpClient already returns { success: true, data, status } format
      // Just return the response directly like categories service does
      return response;
    } catch (error) {
      console.error('SizesService: Error in getSizes:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب المقاسات'
      };
    }
  }

  // Create new size
  async createSize(sizeData) {
    try {
      console.log('SizesService: Received sizeData:', sizeData);
      
      // Create FormData for the request
      const formData = new FormData();
      formData.append('name', sizeData.name);
      formData.append('category_id', sizeData.category_id);
      if (sizeData.additional_info) {
        formData.append('additional_info', sizeData.additional_info);
      }

      console.log('SizesService: Sending as FormData');
      console.log('SizesService: FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      console.log('SizesService: Making POST request to /api/admin/sizes');
      const response = await httpClient.post('/api/admin/sizes', formData);
      console.log('SizesService: Raw response from httpClient:', response);
      
      // httpClient already returns { success: true, data, status } format
      // Just return the response directly like categories service does
      return response;
    } catch (error) {
      console.error('Error creating size:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء إنشاء المقاس'
      };
    }
  }

  // Update size
  async updateSize(id, sizeData) {
    try {
      // Create FormData for the request
      const formData = new FormData();
      formData.append('name', sizeData.name);
      formData.append('category_id', sizeData.category_id);
      if (sizeData.additional_info) {
        formData.append('additional_info', sizeData.additional_info);
      }
      
      // Add _method field for Laravel to recognize this as PUT request
      formData.append('_method', 'PUT');

      console.log('SizesService: Updating size', id, 'with FormData');
      console.log('SizesService: FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      console.log('SizesService: Making POST request to /api/admin/sizes/' + id + ' with _method=PUT');
      const response = await httpClient.post(`/api/admin/sizes/${id}`, formData);
      console.log('SizesService: Raw response from httpClient:', response);
      
      // httpClient already returns { success: true, data, status } format
      // Just return the response directly like categories service does
      return response;
    } catch (error) {
      console.error('Error updating size:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء تحديث المقاس'
      };
    }
  }

  // Delete size
  async deleteSize(id) {
    try {
      console.log('SizesService: Deleting size', id);
      const response = await httpClient.delete(`/api/admin/sizes/${id}`);
      
      // httpClient already returns { success: true, data, status } format
      // Just return the response directly like categories service does
      return response;
    } catch (error) {
      console.error('Error deleting size:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء حذف المقاس'
      };
    }
  }
}

export const sizesService = new SizesService();
